// extracted by mini-css-extract-plugin
export default {"link":"AdminMenu_link__FA7iE","self":"AdminMenu_self__tt+kc"};